import { readFavoriteIds } from '@/components/mixins/api/apiMethodsParticipantFavorite';

// Временная заглушка каталога участников — эмулятор будущих ответов сервера.
//
// Бэк готов целиком: `/participant/page/` применяет и `filter`, и `relation`,
// а `is_favorite` с `favorited_me` приходят в карточке. Проверено на стенде.
//
// Флага два, и оба сняты:
//   FILTER_API_READY   — категории и отбор по ним;
//   FAVORITE_API_READY — поля избранного и отбор по вкладке (в api-миксине).
// Значит, ни один метод отсюда больше не вызывается: файл живёт только ради
// констант вкладок ниже. Их надо перенести и файл удалить.
export const FILTER_API_READY = true;

/** Значения вкладок каталога — они же значения параметра `relation`. */
export const TAB_ALL = 'all';
export const TAB_FAVORITE = 'favorite';
export const TAB_FAVORITED_BY = 'favorited_by';

export default {
  methods: {
    // Раздаёт участнику две категории из конфига — по его id, чтобы при
    // перелистывании страниц выдача не прыгала.
    demoAssignCategories(list, filtersConfig) {
      const category = filtersConfig.find((filter) => filter.name === 'category');
      const values = category?.values || [];
      if (!values.length) return list;

      return list.map((participant) => {
        const first = values[participant.id % values.length];
        const second = values[(participant.id * 7 + 3) % values.length];
        return {
          ...participant,
          category: [...new Set([first.id, second.id])],
        };
      });
    },

    // Отбирает участников по выбранным категориям.
    // Внимание: отбор идёт по уже загруженной странице, поэтому счётчик страниц
    // от сервера остаётся прежним, а страница может оказаться полупустой.
    // Так и задумано на время заглушки — на сервере отбор будет до пагинации.
    demoFilterByCategory(list, selectedIds) {
      if (!Array.isArray(selectedIds) || !selectedIds.length) return list;
      return list.filter((participant) => Array.isArray(participant.category)
        && participant.category.some((id) => selectedIds.includes(id)));
    },

    // Кто добавил меня в избранное. На клиенте этих данных нет вовсе, поэтому
    // берём каждого седьмого — набор постоянный, значит вкладка не скачет
    // при перелистывании.
    demoIsFavoritedBy(participant) {
      return participant.id % 7 === 0;
    },

    /**
     * Дописывает в карточки поля, которые обещаны контрактом: `is_favorite` —
     * из хранилища, `favorited_me` — выдуманный. Экраны читают только их и
     * после прихода бэка не меняются.
     */
    demoApplyFavoriteFields(list) {
      const ids = readFavoriteIds(this.$store.getters.getExhId);
      return list.map((participant) => ({
        ...participant,
        is_favorite: ids.includes(participant.id),
        favorited_me: this.demoIsFavoritedBy(participant),
      }));
    },

    /**
     * Отбирает участников по вкладке — то, что на сервере сделает `relation`.
     * Работает по полям карточки, поэтому вызывается после
     * `demoApplyFavoriteFields()`.
     */
    demoFilterByRelation(list, tab) {
      if (tab === TAB_FAVORITE) return list.filter((participant) => participant.is_favorite);
      if (tab === TAB_FAVORITED_BY) return list.filter((participant) => participant.favorited_me);
      return list;
    },
  },
};
